export const PAGE_SIZE = 100
export const INITIAL_PAGE_NUMBER = 1
